<template>
  <div>
    <div v-for="videoGroup in videoGroups" class="videoGroup" :key="videoGroup.id">
      <div><span>{{videoGroup.name}}</span></div>
      <VideoQueueGroup :videoList="videoGroup.videos" :batchRef="videoGroup.ref"/>
    </div>
  </div>
</template>

<script>
import VideoQueueGroup from '../components/VideoQueueGroup.vue'

export default {
  name: 'VideoCreativeQueue',
  props: {
    videoGroups: Array
  },
  components: {
    VideoQueueGroup
  },
}
</script>

<style lang="scss" scoped>
  .videoGroup {
    margin-top: 15px;
    margin-left: 15px;
  }
</style>
